import React from 'react';
import {
  View,
  Text,
  Pressable,
  ActivityIndicator,
  StyleSheet,
  Platform,
} from 'react-native';
import {CardForm} from 'src/nativeModules/Stripe';
import Settings from 'src/Settings';
import Localized from 'src/constants/AppStrings';
import Styles from 'src/components/Styles';
import {getDescriber as getSnackDescriber} from 'src/components/screens/sendSnack/descriptor/sendasnack/DescriptorType';
interface AddCardModalProps {
  loading: boolean;
  onClose: () => void;
  onAddCard: () => void;
}

export const AddCardModal: React.FC<AddCardModalProps> = ({
  loading,
  onClose,
  onAddCard,
}) => (
  <View style={modalStyles.container}>
    <View style={modalStyles.subContainer}>
      <View style={modalStyles.titleContainer}>
        <Pressable
          accessible
          accessibilityLabel={Localized.Buttons.cancel}
          accessibilityRole="button"
          onPress={onClose}
        >
          <Text
            style={[
              modalStyles.cancelText,
              getSnackDescriber()?.snackDetailsBtnFontSTyle(),
            ]}
          >
            {Localized.Buttons.cancel}
          </Text>
        </Pressable>

        <Text
          accessible
          accessibilityLabel={Localized.Labels.add_card}
          accessibilityRole="text"
          style={modalStyles.boldText}
        >
          {Localized.Labels.add_card}
        </Text>

        {loading ? (
          <View accessible accessibilityState={{busy: loading}}>
            <ActivityIndicator />
          </View>
        ) : (
          <Pressable
            accessible
            accessibilityLabel={Localized.Buttons.done}
            accessibilityRole="button"
            accessibilityHint="Double tap to finish adding a new credit card"
            onPress={onAddCard}
            testID="qa_Done_btn"
          >
            <Text style={modalStyles.boldText}>{Localized.Buttons.done}</Text>
          </Pressable>
        )}
      </View>

      <CardForm
        autofocus
        style={modalStyles.cardForm}
        cardStyle={modalStyles.cardStyle}
      />
    </View>
  </View>
);

const modalStyles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    width: Styles.ScreenWidth / 1.1,
    borderRadius: 10,
    marginBottom: Styles.Spacing.m3,
  },
  subContainer: {
    backgroundColor: Styles.addCardPopupColor,
    paddingHorizontal: Styles.Spacing.m2,
    paddingVertical: Styles.Spacing.m3,
    borderRadius: Styles.Spacing.m2,
  },
  titleContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cancelText: {
    color: Styles.primaryColor,
  },
  boldText: {
    fontWeight: 'bold',
    color: Styles.darkColor,
    fontFamily: Settings.isCanteen() ? 'Arial Black' : undefined,
  },
  cardForm: {
    marginTop: Styles.Spacing.m3,
    height: Platform.OS === 'ios' ? 180 : 300,
  },
  cardStyle: {
    backgroundColor: Styles.addCardPopupColor,
  },
});
